export const CREDIT_LIMIT_APPROACHING_THRESHOLD = 80;

export const BALANCE_ACCOUNT_INIT_DURATION_VITAL_NAME =
  'rum.app.cmui.balance.account_init_duration';

export enum BalanceSignupFlowType {
  CREATION = 'creation',
  MODIFICATION = 'modification',
}
